import { type History } from "history";
import { Component } from "react";
import { Route } from "react-router";

import { jobDetailRoute } from "utilities/flatRoutes/job.routes";
import { lazyLoadWithRetry } from "utilities/react.utilities";
import { routes } from "utilities/routes";

import { BTSuspense } from "commonComponents/btWrappers/BTSuspense/BTSuspense";

import { type IBuilderRiskInsuranceStatusHandler } from "entity/builderRiskInsurance/BuilderRiskInsuranceStatus/BuilderRiskInsuranceStatus.api.handler";
import { type ICategoryDetailHandler } from "entity/category/Category/Category.api.handler";
import { type IJobHandler } from "entity/job/Job.api.handler";

const JobFromTemplate = lazyLoadWithRetry(
    () => import("entity/job/JobFromTemplate/JobFromTemplate"),
);
const Job = lazyLoadWithRetry(() => import("entity/job/Job/Job"));

interface IRouteJobProps {
    parentRoute: string;
    history: History;
    beforeClose: () => Promise<void>;
    onSave?: () => void;
    handler?: IJobHandler;
    briHandler?: IBuilderRiskInsuranceStatusHandler;
    onBack?: () => void;
    categoryHandler?: ICategoryDetailHandler;
}
export class RouteJob extends Component<IRouteJobProps> {
    render() {
        return (
            <>
                <Route
                    path={this.props.parentRoute + jobDetailRoute.path}
                    render={(routeProps) => {
                        const urlParams = routeProps.match.params;
                        const defaultTab = urlParams.defaultTab ? urlParams.defaultTab : undefined;

                        const modalConfig = {
                            parentRoute: this.props.parentRoute,
                            beforeClose: async () => {
                                await this.props.beforeClose();
                                this.props.history.push(this.props.parentRoute);
                            },
                        };

                        const jobId = parseInt(urlParams.jobId);
                        const accessedFromContact = urlParams.accessedFromContact
                            ? urlParams.accessedFromContact === "true"
                            : false;
                        const accessedFromLead = urlParams.accessedFromLead
                            ? urlParams.accessedFromLead === "true"
                            : false;
                        const ownerInvoiceId = urlParams.ownerInvoiceId
                            ? parseInt(urlParams.ownerInvoiceId)
                            : undefined;
                        let openCondensed = urlParams.openCondensed
                            ? urlParams.openCondensed === "true"
                            : false;
                        const query = new URLSearchParams(routeProps.location.search);
                        if (query.get("openCondensed") === "true") {
                            openCondensed = true;
                        }

                        return (
                            <BTSuspense>
                                <Job
                                    id={jobId}
                                    defaultTab={defaultTab}
                                    modalConfig={modalConfig}
                                    accessedFromContact={accessedFromContact}
                                    accessedFromLead={accessedFromLead}
                                    onSave={this.props.onSave}
                                    ownerInvoiceId={ownerInvoiceId}
                                    openCondensed={openCondensed}
                                    handler={this.props.handler}
                                    briHandler={this.props.briHandler}
                                    {...routeProps}
                                    onBack={this.props.onBack}
                                    categoryHandler={this.props.categoryHandler}
                                />
                            </BTSuspense>
                        );
                    }}
                />
                <Route
                    path={this.props.parentRoute + routes.job.jobFromTemplate}
                    render={(routeProps) => {
                        const modalConfig = {
                            parentRoute: this.props.parentRoute,
                            beforeClose: () => {
                                this.props.history.push(this.props.parentRoute);
                            },
                        };

                        const urlParams = routeProps.match.params;
                        const sourceTemplateId = parseInt(urlParams.sourceTemplateId);
                        return (
                            <BTSuspense>
                                <JobFromTemplate
                                    modalConfig={modalConfig}
                                    {...routeProps}
                                    sourceTemplateId={sourceTemplateId}
                                />
                            </BTSuspense>
                        );
                    }}
                />
            </>
        );
    }
}

export class RouteTemplateJobForJobPage extends Component<
    IRouteJobProps & { loadJobForFullPage?: () => Promise<void> }
> {
    render() {
        return (
            <Route
                path={this.props.parentRoute + routes.job.jobFromTemplate}
                render={(routeProps) => {
                    const modalConfig = {
                        parentRoute: this.props.parentRoute,
                        beforeClose: () => {
                            this.props.history.replace(this.props.parentRoute);
                        },
                    };

                    const urlParams = routeProps.match.params;
                    const sourceTemplateId = parseInt(urlParams.sourceTemplateId);
                    return (
                        <BTSuspense>
                            <JobFromTemplate
                                loadJobForFullPage={this.props.loadJobForFullPage}
                                modalConfig={modalConfig}
                                {...routeProps}
                                sourceTemplateId={sourceTemplateId}
                            />
                        </BTSuspense>
                    );
                }}
            />
        );
    }
}
